const CNPJ_LENGTH = 12
const REGEX_CNPJ = /^[A-Z\d]{12}\d{2}$/
const REGEX_MASK_CHARS = /[./-]/g
const REGEX_INVALID_CHARS = /[^A-Z\d./-]/i
const ASCII_BASE = '0'.charCodeAt(0)
const WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const CNPJ_ZEROED = '00000000000000'

/**
 * Valida CNPJ numérico (legado) e alfanumérico (Resolução CGSIM nº 62 / IN RFB nº 2.119/2022).
 * Radical (posições 1-8): aceita A-Z e 0-9.
 * Ordem (9-12) e DV (13-14): exclusivamente numéricos.
 * Algoritmo baseado na nota técnica oficial da RFB (charCodeAt - 48).
 */
export function useDocumentCNPJIsValid (cnpj: string): boolean {
  if (REGEX_INVALID_CHARS.test(cnpj)) {
    return false
  }

  const cleaned = cnpj.replace(REGEX_MASK_CHARS, '').toUpperCase()

  if (!REGEX_CNPJ.test(cleaned) || cleaned === CNPJ_ZEROED) {
    return false
  }

  const dvInformado = cleaned.substring(CNPJ_LENGTH)
  const dvCalculado = calculaDV(cleaned.substring(0, CNPJ_LENGTH))

  return dvInformado === dvCalculado
}

function calculaDV (base: string): string {
  let sumDV1 = 0
  let sumDV2 = 0

  for (let i = 0; i < CNPJ_LENGTH; i++) {
    const value = base.charCodeAt(i) - ASCII_BASE
    sumDV1 += value * WEIGHTS[i + 1]
    sumDV2 += value * WEIGHTS[i]
  }

  const dv1 = sumDV1 % 11 < 2 ? 0 : 11 - (sumDV1 % 11)
  sumDV2 += dv1 * WEIGHTS[CNPJ_LENGTH]
  const dv2 = sumDV2 % 11 < 2 ? 0 : 11 - (sumDV2 % 11)

  return `${dv1}${dv2}`
}
